import React, { useEffect, useState } from "react";
import log from "loglevel";
import ChoiceQuestion from "../QuestionTypes/ChoiceQuestion"
import FillBlanks from "../QuestionTypes/FillBlanks";
import Subjective from "../QuestionTypes/Subjective";
import Numeric from "../QuestionTypes/Numeric";

const Question = React.forwardRef(
    (
        { labId, question, index, previousResponse, updateResponse, isDisabled, Eval },
        ref
    ) => {

        const [today, setToday] = useState(new Date());
        const { question_type, marks, questionanswer_set } = question;
        const { response_options_ids } = previousResponse || { response_options_ids: [] }

        log.log("Evaluation -->", Eval);
        log.log("question  : ", question);

        const autoCalculateScoredMarks = async (scored_marks) => {
            // log.log("autoCalculating Marks function")
            // const response = await actions.autoCalculateScoredMarksRequest(question, previousResponse.id, scored_marks);
            updateResponse();
        }

        useEffect(() => {
            const doStuff = async () => {
                let correct_answers = 0;
                updateResponse();
                //  log.log("result calculate-2",question_type,response_options_ids)

                if (question_type == "S" || question_type == "M") {

                    if (Array.isArray(questionanswer_set)) {
                        for (let ans of questionanswer_set) {
                            if (response_options_ids && response_options_ids.includes(ans.answer_option)) {
                                correct_answers += 1;
                            } else {
                                correct_answers -= 1
                            }
                        }
                        // log.log("result cqalculate")
                        if (correct_answers == questionanswer_set.length) {
                            autoCalculateScoredMarks(marks)
                        } else {
                            autoCalculateScoredMarks(0.0);
                        }
                    }

                } else if (question_type == "N") {
                    let isCorrect = false;
                    for (let ansObj of questionanswer_set) {
                        let trimmedString = ansObj.answer.trim();
                        let onlyOptions = trimmedString;
                        if (trimmedString[0] === '[') {
                            onlyOptions = trimmedString.slice(1, -1);
                        }
                        let allPossible = onlyOptions.split(',');
                        let numerals = allPossible;
                        if (numerals[0][0] === '"' || numerals[0][0] === "'") {
                            numerals = numerals.map((str) => str.trim().slice(1, -1));
                        }
                        numerals = numerals.map(parseFloat);
                        if (numerals.includes(parseFloat(previousResponse?.response_text))) {
                            isCorrect = true;
                            break;
                        }
                    }
                    if (isCorrect) {
                        autoCalculateScoredMarks(marks);
                    } else {
                        autoCalculateScoredMarks(0);
                    }
                } else if (question_type == "F") {
                    log.log("Fill in the blanks, ", questionanswer_set)
                    let lines = previousResponse?.response_text?.split?.(/\r?\n/);
                    if (lines?.length != questionanswer_set?.length) {
                        autoCalculateScoredMarks(0);
                        return;
                    }

                    let num_words = lines.length;
                    for (var i = 0; i < num_words; i++) {
                        let blanksInsensitive = false;
                        let caseInsensitive = false;
                        let ans_string = questionanswer_set[i].answer.slice(1, -1);
                        let resp_string = lines[i];
                        let start = 0
                        if (ans_string.length > 4 && ans_string.slice(0, 4) == "(?b)") {
                            blanksInsensitive = true;
                            start = 4;
                        }
                        if (ans_string.length > 4 && ans_string.slice(0, 4) == "(?i)") {
                            caseInsensitive = true;
                            start = 4;
                        }

                        if (ans_string.length > 8 && ans_string.slice(4, 8) == "(?b)") {
                            blanksInsensitive = true;
                            start = 8;
                        }

                        if (ans_string.length > 8 && ans_string.slice(4, 8) == "(?i)") {
                            caseInsensitive = true;
                            start = 8;
                        }

                        ans_string = ans_string.slice(start);
                        if (caseInsensitive) {
                            ans_string = ans_string.toUpperCase();
                            resp_string = resp_string.toUpperCase();
                        }

                        if (blanksInsensitive) {
                            ans_string = ans_string.replace(/\s/g, "");
                            resp_string = resp_string.replace(/\s/g, "");
                        }

                        if (ans_string != resp_string) {
                            autoCalculateScoredMarks(0);
                        }

                    }
                    autoCalculateScoredMarks(marks);
                }
            }
            doStuff();
        }, []);

        switch (question_type) {
            case "S":
            case "M":
                //return <div ref={ref}><ChoiceQuestion courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={disable} Eval={Eval}/></div>;
                return <div ref={ref}><ChoiceQuestion courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={isDisabled} Eval={Eval} /></div>;

            case "D":
                return <div ref={ref}><Subjective courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={isDisabled} Eval={Eval} /></div>;
            case "F":
                return <div ref={ref}><FillBlanks courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={isDisabled} Eval={Eval} /></div>;
            case "N":
                return <div ref={ref}><Numeric courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={isDisabled} Eval={Eval} /></div>;
            default:
                return <div>Error in question</div>;
        }
    }
);

export default Question;